import { render } from "./HeroiconsOutlineSortAscending.vue?vue&type=template&id=5bcb094a"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSortAscending.vue"]])

export default __exports__